// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__AE9lk","userInfo":"Profile_userInfo__80wi+","info":"Profile_info__ad6Gr","menu":"Profile_menu__wcMd5"};